/* eslint-disable max-classes-per-file */
import { MainTableFilterModel } from 'src/app/shared/models/main-table-filter.model';
import {
  IDepartmentPauseCancelRequest,
  IDepartmentPauseFinishRequest,
  IDepartmentPausePeriodRequest,
  IDepartmentPauseSettings,
} from '../models/department-pause.model';

export class LoadDepartmentPauseLog {
  static readonly type = '[DepartmentPause] Load Pause Log';
  constructor(
    public departmentId: string,
    public filter?: MainTableFilterModel
  ) {}
}

export class LoadDepartmentPauseCreateAvailability {
  static readonly type = '[DepartmentPause] Load Create Availability';
  constructor(public departmentId: string) {}
}

export class LoadDepartmentPauseSettings {
  static readonly type = '[DepartmentPause] Load Pause Settings';
  constructor(public departmentId: string) {}
}

export class UpdateDepartmentPauseSettings {
  static readonly type = '[DepartmentPause] Update Pause Settings';
  constructor(
    public departmentId: string,
    public settings: IDepartmentPauseSettings
  ) {}
}

export class CreateDepartmentPausePeriod {
  static readonly type = '[DepartmentPause] Create Pause Period';
  constructor(
    public departmentId: string,
    public pause: IDepartmentPausePeriodRequest
  ) {}
}

export class UpdateDepartmentPause {
  static readonly type = '[DepartmentPause] Update Pause';
  constructor(
    public departmentId: string,
    public pauseId: string,
    public pause: IDepartmentPausePeriodRequest
  ) {}
}

export class FinishDepartmentPause {
  static readonly type = '[DepartmentPause] Finish Pause';
  constructor(
    public departmentId: string,
    public pauseId: string,
    public finish: IDepartmentPauseFinishRequest
  ) {}
}

export class CancelDepartmentPause {
  static readonly type = '[DepartmentPause] Cancel Pause';
  constructor(
    public departmentId: string,
    public pauseId: string,
    public cancel: IDepartmentPauseCancelRequest
  ) {}
}
